import { useEffect, useState } from "react";
import { ACTION_LABELS, api, fmtDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const PAGE = 50;

export function AdminAudit() {
  const [data, setData] = useState({ items: [], total: 0, actions: [] });
  const [action, setAction] = useState("all");
  const [q, setQ] = useState("");
  const [skip, setSkip] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/audit", { params: { action: action === "all" ? "" : action, q, skip, limit: PAGE } }).then((r) => setData(r.data)), 250);
    return () => clearTimeout(t);
  }, [action, q, skip]);

  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row gap-2">
        <Input value={q} onChange={(e) => { setQ(e.target.value); setSkip(0); }} placeholder="Filtrer par utilisateur, document, détail…" className="flex-1 bg-white" data-testid="audit-search-input" />
        <Select value={action} onValueChange={(v) => { setAction(v); setSkip(0); }}>
          <SelectTrigger className="sm:w-64 bg-white" data-testid="audit-action-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">Toutes les actions</SelectItem>
            {data.actions.map((a) => <SelectItem key={a} value={a}>{ACTION_LABELS[a] || a}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="bg-white border rounded-xl overflow-x-auto">
        <table className="w-full text-sm min-w-[820px]" data-testid="audit-table">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="text-left px-4 py-3">Date</th><th className="text-left px-4 py-3">Utilisateur</th><th className="text-left px-4 py-3">Action</th><th className="text-left px-4 py-3">Élément</th><th className="text-left px-4 py-3">Détails</th><th className="text-left px-4 py-3">IP</th></tr>
          </thead>
          <tbody className="divide-y">
            {data.items.map((a) => (
              <tr key={a.id}>
                <td className="px-4 py-2.5 text-xs whitespace-nowrap">{fmtDate(a.at, true)}</td>
                <td className="px-4 py-2.5">{a.user_name}</td>
                <td className="px-4 py-2.5"><span className="text-xs font-semibold bg-slate-100 rounded px-2 py-0.5">{ACTION_LABELS[a.action] || a.action}</span></td>
                <td className="px-4 py-2.5 max-w-[220px] truncate">{a.target_name}</td>
                <td className="px-4 py-2.5 text-xs text-slate-500 max-w-[240px] truncate" title={a.details}>{a.details}</td>
                <td className="px-4 py-2.5 text-xs font-mono text-slate-500">{a.ip}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-between text-sm">
        <span className="text-slate-500" data-testid="audit-total">{data.total} entrée(s)</span>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" disabled={skip === 0} onClick={() => setSkip(Math.max(0, skip - PAGE))} data-testid="audit-prev-btn">Précédent</Button>
          <Button variant="outline" size="sm" disabled={skip + PAGE >= data.total} onClick={() => setSkip(skip + PAGE)} data-testid="audit-next-btn">Suivant</Button>
        </div>
      </div>
    </div>
  );
}
